"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterMatchResult = void 0;
class RouterMatchResult {
    constructor(routeConfig, data, getContext) {
        this.routeConfig = routeConfig || {
            path: '',
            name: '',
            parents: []
        };
        this.data = data || { query: {}, params: {} };
        this.notFount = !routeConfig;
        this.redirect = (routeConfig && routeConfig.redirect) || null;
        this.getContext = getContext;
        this.guardsResult = null;
    }
    executeGuards() {
        let guardResult = { allow: true };
        this.routeConfig.parents.concat(this.routeConfig).some((parent) => {
            (parent.guards || []).some((guard) => {
                guardResult = guard(this.getContext());
                return !guardResult.allow;
            });
            return !guardResult.allow;
        });
        this.guardsResult = guardResult;
        return Object.assign({}, this.guardsResult);
    }
    getName() {
        return this.routeConfig.name || '';
    }
    getResourceName() {
        let resourceName = '';
        const items = [this.routeConfig].concat(this.routeConfig.parents);
        items.some((i) => {
            resourceName = i.resourceName || '';
            return resourceName;
        });
        return resourceName || null;
    }
    isNotFound() {
        return this.notFount;
    }
    getParams() {
        return Object.assign({}, this.data.params);
    }
    getQuery() {
        return Object.assign({}, this.data.query);
    }
    hasRedirect() {
        return !!this.redirect;
    }
    getRedirect() {
        if (!this.redirect) {
            throw new Error('RouterMatchResult error: routerMatchResult is not redirect, before get redirect data check by "hasRedirect" method');
        }
        return Object.assign({}, this.redirect);
    }
    isRouteActive(name) {
        return (this.routeConfig.name === name ||
            this.routeConfig.parents.some((parent) => parent.name === name));
    }
    match(getter) {
        let result = null;
        if (this.isDisallow()) {
            const guardResult = this.getGuardResult();
            return getter(guardResult.stubName || '') || null;
        }
        result = getter(this.getName());
        if (!result) {
            this.routeConfig.parents.reverse().some((parent) => {
                result = getter(parent.name) || null;
                return !!result;
            });
        }
        return result;
    }
    isAllow() {
        return this.getGuardResult().allow;
    }
    isDisallow() {
        return !this.getGuardResult().allow;
    }
    getGuardResult() {
        if (!this.guardsResult) {
            return this.executeGuards();
        }
        return Object.assign({}, this.guardsResult);
    }
}
exports.RouterMatchResult = RouterMatchResult;
//# sourceMappingURL=RouterMatchResult.js.map